import { UserInfo } from '../models/UserInfo';

const USER_INFO_LOCAL_STORAGE = 'userInfo';

function stripAuthTokens(userInfo: UserInfo | {}): Partial<UserInfo> {
	const raw = userInfo as Record<string, unknown>;
	const {
		token: _token,
		refreshToken: _refreshToken,
		expirationTime: _expirationTime,
		refreshTokenExpirationTime: _refreshTokenExpirationTime,
		refreshTokenTimeRemainingInSeconds: _refreshTokenTimeRemainingInSeconds,
		timeRemainingInSeconds: _timeRemainingInSeconds,
		...safeUserInfo
	} = raw;
	return safeUserInfo as Partial<UserInfo>;
}

export function setUserInfo(userInfo: UserInfo | {}) {
	localStorage.setItem(USER_INFO_LOCAL_STORAGE, JSON.stringify(stripAuthTokens(userInfo)));
}

export function getUserInfo(): UserInfo | undefined {
	return stripAuthTokens(JSON.parse(localStorage.getItem(USER_INFO_LOCAL_STORAGE) || '{}')) as UserInfo;
}

export function deleteUserInfo() {
	localStorage.removeItem(USER_INFO_LOCAL_STORAGE);
}

// Sessions stored before the move to cookies still hold the access and refresh tokens; drop them.
(function removeLegacyTokens() {
	try {
		const stored = localStorage.getItem(USER_INFO_LOCAL_STORAGE);
		if (stored && /"(token|refreshToken|expirationTime)"/.test(stored)) {
			setUserInfo(JSON.parse(stored));
		}
	} catch {
		// unreadable entry: leave it to the normal sign-in flow
	}
})();
